import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService, CommonService, LeadService, AlertService, ProfileService, FileService } from '../../_services/'; 

import * as fileSaver from 'file-saver';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-files-list',
  templateUrl: './files-list.component.html',
  styleUrls: ['./files-list.component.scss']
})
export class FilesListComponent implements OnInit {
  items : any[] = [];
  fileList : any[];
  private subscription: Subscription;
  constructor(
    private _common:CommonService,
    public _admin: AdminService,
    public _lead: LeadService,
    private _alert : AlertService,
    private _file: FileService,
  ) { }

  ngOnInit() {
    this.getFileList();
  }

  getFileList(){
    this._common.showLoader(true);
    this.subscription = this._lead.getFileList().subscribe(res =>{
      this._common.showLoader(false);
     this.items = res;
     this.fileList = [];
      for(let i=0;i<this.items.length; i++){
        let fileExt = this.items[i].payload.doc.data().filepath.split('?')[0].split('/').reverse()[0].split('.').reverse()[0].toLowerCase();
        this.fileList.push({
          filePath : this.items[i].payload.doc.data().filepath,
          fileType : (fileExt=="jpg" || fileExt=="jpeg" || fileExt=="png") ? '':'placeholder'
        });
      }
    },error=>{
      alert('Something went wrong!');
    });
  }

  download(url) {
    // this._file.getData(url)
    // .subscribe(
    //   imgData =>{ console.log(imgData);},
    //   err => console.log(err)
    // );
    this._file.downloadFile(url).subscribe(response => {
      
			let blob:any = new Blob([response.blob()], { type: 'text/json; charset=utf-8' });
			// const url= window.URL.createObjectURL(blob);
			// window.open(url);
			// window.location.href = response.url;
      fileSaver.saveAs(blob, `download.${url.split('?')[0].split('.').reverse()[0]}`);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully'); 
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }
  
}
